var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnnotationsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 57,
    viewBox: "0 0 61 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_2171_5719)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.375,
    y: 2.52246,
    width: 44,
    height: 44,
    rx: 22,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bii_2171_5719)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6422 18.2891H36.1856H20.6422ZM20.6422 24.7891H26.8596H20.6422ZM28.4139 37.7891L22.1965 31.2891H17.5335C16.709 31.2891 15.9183 30.9467 15.3353 30.3372C14.7523 29.7277 14.4248 28.901 14.4248 28.0391V15.0391C14.4248 14.1771 14.7523 13.3505 15.3353 12.741C15.9183 12.1315 16.709 11.7891 17.5335 11.7891H39.2943C40.1188 11.7891 40.9095 12.1315 41.4925 12.741C42.0755 13.3505 42.403 14.1771 42.403 15.0391V28.0391C42.403 28.901 42.0755 29.7277 41.4925 30.3372C40.9095 30.9467 40.1188 31.2891 39.2943 31.2891H34.6313L28.4139 37.7891Z",
    stroke: "white",
    strokeOpacity: 0.14,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.0415 18.6557H35.7081H21.0415ZM21.0415 24.5224H26.9081H21.0415ZM28.3748 36.2557L22.5081 30.3891H18.1081C17.3302 30.3891 16.5841 30.08 16.034 29.5299C15.4839 28.9798 15.1748 28.2337 15.1748 27.4557V15.7224C15.1748 14.9444 15.4839 14.1983 16.034 13.6482C16.5841 13.0981 17.3302 12.7891 18.1081 12.7891H38.6415C39.4194 12.7891 40.1655 13.0981 40.7157 13.6482C41.2658 14.1983 41.5748 14.9444 41.5748 15.7224V27.4557C41.5748 28.2337 41.2658 28.9798 40.7157 29.5299C40.1655 30.08 39.4194 30.3891 38.6415 30.3891H34.2415L28.3748 36.2557Z",
    stroke: "#12C1E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9737 10.3558H14.7937V11.5225H14.0804V10.3558H12.9004V9.68913H14.0804V8.52246H14.7937V9.68913H15.9737V10.3558Z",
    fill: "#12C1E8",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9737 7.35579H25.7937V8.52246H25.0804V7.35579H23.9004V6.68913H25.0804V5.52246H25.7937V6.68913H26.9737V7.35579Z",
    fill: "#12C1E8",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9737 20.3558H10.7937V21.5225H10.0804V20.3558H8.90039V19.6891H10.0804V18.5225H10.7937V19.6891H11.9737V20.3558Z",
    fill: "#12C1E8",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_2171_5719",
    x: 0.375,
    y: 0.522461,
    width: 60,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2171_5719"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2171_5719",
    result: "effect2_dropShadow_2171_5719"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2171_5719",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bii_2171_5719",
    x: 8.23867,
    y: 5.60293,
    width: 40.3508,
    height: 38.3723,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 2.59307
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2171_5719"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2171_5719",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.66222,
    dy: 1.66222
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.831111
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2171_5719"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.66222,
    dy: -1.66222
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.831111
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0536471 0 0 0 0 0.576646 0 0 0 0 0.691451 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_2171_5719",
    result: "effect3_innerShadow_2171_5719"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnotationsIcon);
export default __webpack_public_path__ + "static/media/annotationsIcon.82b9ef76a7c84f8fd5eab10c49ec598d.svg";
export { ForwardRef as ReactComponent };